import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const InfectionKindList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="infectionKind"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default InfectionKindList;
